import React, { useState } from "react";
import { EmailDecryptModal } from "../components/common/EmailDecryptModal";
import { ServiceCard } from "../components/services/ServiceCard";
import { useLanguage } from "../contexts/LanguageContext";
import styles from "./Services.module.css";
import { TranslationKey } from "../i18n/translations";

interface Service {
  id: string;
  titleKey: string;
  descriptionKey: string;
  priceEn: string;
  priceDe: string;
  features: string[];
  image?: string;
}

const services: Service[] = [
  {
    id: "wedding",
    titleKey: "services.wedding.title",
    descriptionKey: "services.wedding.description",
    priceEn: "£1,050",
    priceDe: "1,200 EUR",
    features: [
      "services.wedding.feature.1",
      "services.wedding.feature.2",
      "services.wedding.feature.3",
      "services.wedding.feature.4",
      "services.wedding.feature.5"
    ]
  },
  {
    id: "portrait",
    titleKey: "services.portrait.title",
    descriptionKey: "services.portrait.description",
    priceEn: "£140",
    priceDe: "150 EUR",
    features: [
      "services.portrait.feature.1",
      "services.portrait.feature.2",
      "services.portrait.feature.3",
      "services.portrait.feature.4",
      "services.portrait.feature.5",
      "services.portrait.feature.6"
    ]
  },
  {
    id: "commercial",
    titleKey: "services.commercial.title",
    descriptionKey: "services.commercial.description",
    priceEn: "£500",
    priceDe: "575 EUR",
    features: [
      "services.commercial.feature.1",
      "services.commercial.feature.2",
      "services.commercial.feature.3",
      "services.commercial.feature.4",
      "services.commercial.feature.5",
      "services.commercial.feature.6"
    ]
  },
  {
    id: "event",
    titleKey: "services.event.title",
    descriptionKey: "services.event.description",
    priceEn: "£250",
    priceDe: "290 EUR",
    features: [
      "services.event.feature.1",
      "services.event.feature.2",
      "services.event.feature.3",
      "services.event.feature.4",
      "services.event.feature.5",
      "services.event.feature.6"
    ]
  },
  {
    id: "car",
    titleKey: "services.car.title",
    descriptionKey: "services.car.description",
    priceEn: "£200",
    priceDe: "230 EUR",
    features: [
      "services.car.feature.1",
      "services.car.feature.2",
      "services.car.feature.3",
      "services.car.feature.4",
      "services.car.feature.5",
      "services.car.feature.6"
    ]
  },
  {
    id: "family",
    titleKey: "services.family.title",
    descriptionKey: "services.family.description",
    priceEn: "£175",
    priceDe: "200 EUR",
    features: [
      "services.family.feature.1",
      "services.family.feature.2",
      "services.family.feature.3",
      "services.family.feature.4",
      "services.family.feature.5",
      "services.family.feature.6"
    ]
  }
];

export const Services: React.FC = () => {
  const [isEmailModalOpen, setIsEmailModalOpen] = useState(false);
  const { t } = useLanguage();

  const handleInquire = () => {
    setIsEmailModalOpen(true);
  };

  return (
    <div className={styles.services}>
      <div className={styles.hero}>
        <div className={styles.heroContent}>
          <h1 className={styles.heroTitle}>{t("services.title")}</h1>
          <p className={styles.heroSubtitle}>{t("services.subtitle")}</p>
        </div>
      </div>

      <div className={styles.servicesGrid}>
        {services.map((service) => (
          <ServiceCard
            key={service.id}
            service={service}
            onInquire={handleInquire}
          />
        ))}
      </div>

      <div className={styles.cta}>
        <div className={styles.ctaContent}>
          <h2 className={styles.ctaTitle}>{t("services.readyToBook")}</h2>
          <p className={styles.ctaText}>{t("services.contactForQuote")}</p>
          <button
            className={styles.ctaButton}
            onClick={() => setIsEmailModalOpen(true)}
          >
            {t("services.getInTouch")}
          </button>
        </div>
      </div>

      <EmailDecryptModal
        isOpen={isEmailModalOpen}
        onClose={() => setIsEmailModalOpen(false)}
      />
    </div>
  );
};
